// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// const baseurl = 'https://api.redeca.unidrogas.com/';
// const webContentBaseUrl = 'https://api.redeca.unidrogas.com/';

//dropopular
// const baseurl = 'https://dropopular.mefid.com.co/';
// const webContentBaseUrl = 'https://dropopular.mefid.com.co/';

// dev (prueba idsucursal para seller)
const baseurl = 'https://superpesos.superat.com.co/';
const webContentBaseUrl = 'https://superpesos.superat.com.co/';

export const environment = {
  production: false,

  LOGIN: baseurl + 'login/',
  LOGOUT: baseurl + 'logout/',
  RESET: baseurl + 'change-password/',


  seller: {
    SUCURSALES: baseurl + 'seller/surcusal_list/',
    CLIENT: baseurl + 'seller/participant_info/',
    SMS: baseurl + 'seller/send_verify_phone/',
    VERIFY: baseurl + 'seller/verify_phone/',
    PHONEMODIFY: baseurl + 'seller/update_phone/',
    LISTREWARDS: baseurl + 'seller/reward/',
    EMAIL: baseurl + 'seller/send_verify_email/',
    VERIFYEMAIL: baseurl + 'seller/verify_email/',
    UPDATEMAIL: baseurl + 'seller/update_email/',
    UPDATEINFOCLIENT: baseurl + 'seller/participant_update/',
    GETSTADISTICSHOME: baseurl + 'seller/users/statistics/'

  },

  admin: {
    CHECK_ADMIN: baseurl + 'administrator/check_admin/',
    LISTAR_BANNERS: baseurl + 'administrator/banner_list/',
    SELECCIONAR_BANNER: baseurl + 'administrator/banner_select/',
    SUBIRBANNER: baseurl + 'administrator/banner_upload/',
    LISTAR_TELEFONOS_VERIFICADOS:
      baseurl + 'administrator/list_cell_verification/',
    LISTAR_CLIENTES: baseurl + 'administrator/list_client/',
    LISTAR_CLIENTES_ACTUALIZADOS: baseurl + 'administrator/list_client_update/',
    LISTAR_EVENTOS: baseurl + 'administrator/list_loguser/',
    LISTAR_CUPONES: baseurl + 'administrator/list_redeem_client/',
    LISTAR_VENDEDORES: baseurl + 'administrator/list_seller/',
    LISTAR_CUPONES_REDIMIDOS: baseurl + 'administrator/redeem_ps_list/',
    CREAR_USUARIO: baseurl + 'administrator/register_user/',
    INFORMACION_DEL_USUARIO: baseurl + 'administrator/update_status_user/',
    ACTUALIZAR_USUARIO: baseurl + 'administrator/update_status_user/',
    ACTUALIZACION_PARCIAL_DEL_USUARIO_PATCH:
      baseurl + 'administrator/update_status_user/',
    LISTARUSUARIOS: baseurl + 'users/users_list/',
    LOGEXCEL: baseurl + 'administrator/log/xls/',
    LOGREDEMPTION: baseurl + 'administrator/redemption/xls/',
    VERIFYEXCEL: baseurl + 'administrator/cell_verification/xls/',
    LOGSECURITY: baseurl + 'administrator/list_logsecurity/',
    XSLSECURITY: baseurl + 'administrator/logsecurity/xls/',
    XSLCLIENTUPDATE: baseurl + 'administrator/client_update/xls/',
    XSLSELLER: baseurl + 'administrator/seller/xls/',
    XSLCLIENT: baseurl + 'administrator/client/xls/',
    EMAIL_VERIFIED: baseurl + 'administrator/list_email_verification/',
    XSLEMAIL_VERIFIED: baseurl + 'administrator/email_verification/xls/',
    RESETADMIN: baseurl + 'administrator/reset_password_seller/',
    ADMINTDVREDEMPTION: baseurl + 'administrator/redemption-clients_tdv/'

  },

  webContent: {
    BANNER: webContentBaseUrl + 'api/banner/',
    ACUMULATE: webContentBaseUrl + 'api/acumulate/',
    COUPONS: webContentBaseUrl + 'api/coupons/',
    INFO_CAROUSEL: webContentBaseUrl + 'api/info-carousel/',
    INFO_CAROUSEL_GALLERY: webContentBaseUrl + 'api/info-carousel/gallery/',
    BRANDS: webContentBaseUrl + 'api/brands/',
    POINTS_STEPS: webContentBaseUrl + 'api/points/steps/',
    POINTS_DECORATIVES: webContentBaseUrl + 'api/points/decoratives/',
    TEXTS: webContentBaseUrl + 'api/texts/',
    PAGE_DATA: webContentBaseUrl + 'api/page-data/',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
